import React from "react";
import PageTitle from "../components/PageTitle";
import Contact from "../components/Contact";

function Contatti() {
  return (
    <div className="pb-[5%]">
      <PageTitle title="Contatti" />
      <Contact
        indirizzo="Vicolo della Scala 1"
        telefono="+39 06 5768364"
        mappa="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d5940.222333687676!2d12.464849612944619!3d41.890466264518004!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x132f6047432703a3%3A0xd8db9ac999d72ad8!2sVicolo%20della%20Scala%2C%201%2C%2000153%20Roma%20RM!5e0!3m2!1sen!2sit!4v1716478546284!5m2!1sen!2sit"
        citta="Roma"
      />
      <Contact
        indirizzo="Via Empedocle Restivo 82"
        telefono="+39 091 768364"
        mappa="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d784.4476139901317!2d13.334615628602304!3d38.145065152947254!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1319e8ca0b603b99%3A0x665d6a1a53f9c681!2sVia%20Empedocle%20Restivo%2C%2082%2C%2090144%20Palermo%20PA!5e0!3m2!1sen!2sit!4v1716479267613!5m2!1sen!2sit"
        citta="Palermo"
      />{" "}
    </div>
  );
}

export default Contatti;
